import useFetch from 'utils/hooks/useFetch'
import { ApiCreateExpense, ApiDeleteExpense, ApiGetExpenseById, ApiGetExpenseList, ApiUpdateExpense } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function ExpenseService() {
    const { showFail } = useModal()

    const { fetch: apiCreateExpense } = useFetch(ApiCreateExpense)
    const { fetch: apiUpdateExpense } = useFetch(ApiUpdateExpense)
    const { fetch: apiDeleteExpense } = useFetch(ApiDeleteExpense)
    const { fetch: apiGetExpenseList } = useFetch(ApiGetExpenseList)
    const { fetch: apiGetExpenseById } = useFetch(ApiGetExpenseById)
 
    const fetchCreateExpense = async (expenseDate, categoryId, amount, remark, locationId) => {
        const res = await apiCreateExpense({
            data: {
                expenseDate, 
                categoryId, 
                amount, 
                remark,
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateExpense = async (expenseId, expenseDate, categoryId, amount, remark, locationId) => {
        const res = await apiUpdateExpense({
            data: {
                expenseId,
                expenseDate, 
                categoryId, 
                amount, 
                remark,
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteExpense = async (expenseId, status) => {
        const res = await apiDeleteExpense({
            data: {
                expenseId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchExpenseList = async (dateFrom, dateTo, categoryId, remark, status, locationId, pageSize, pageIndex) => {
        const res = await apiGetExpenseList({
            data: {
                dateFrom,
                dateTo,
                categoryId,
                remark,
                status,
                locationId,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchExpenseById = async (expenseId) => {
        const res = await apiGetExpenseById({
            data: {
                expenseId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCreateExpense,
        fetchUpdateExpense,
        fetchDeleteExpense,
        fetchExpenseList,
        fetchExpenseById
    }
}